import { Grid } from '@mui/material'
import { MainCard } from 'Components/Cards'
import { ConfirmationDialog } from 'Components/Dialog'
import { SectionLoader } from 'Components/Section'
import { IKoreanSchoolYearlyStatistic } from 'Entities/koreanSchoolYearlyStatistics'
import moment from 'moment'
import { useCallback, useMemo, useState } from 'react'
import { KoreanSchoolYearlyEditDialog } from './KoreanSchoolYearlyEditDialog'
import { useKoreanSchoolYearlyStatistics } from '../Hooks/useKoreanSchoolYearlyStatistics'

const getCardText = (item: IKoreanSchoolYearlyStatistic) => {
  const total = item.totalCount ?? item.schoolCount + item.universityCount
  return `${item.year}: школы — ${item.schoolCount}, университеты — ${item.universityCount}, всего — ${total}`
}

export const KoreanSchoolYearlyStatisticsList = () => {
  const { items, isLoading, isFetching, deleteMutation } = useKoreanSchoolYearlyStatistics()
  const [removeId, setRemoveId] = useState<number | null>(null)
  const [editItem, setEditItem] = useState<IKoreanSchoolYearlyStatistic | null>(null)

  const onRemoveConfirm = useCallback(() => {
    if (removeId == null) return
    deleteMutation.mutate(removeId, {
      onSettled: () => setRemoveId(null),
    })
  }, [deleteMutation, removeId])

  const sortedItems = useMemo(
    () => [...items].sort((a, b) => Number(b.year) - Number(a.year)),
    [items],
  )

  return (
    <>
      <ConfirmationDialog
        open={removeId !== null}
        onAccept={onRemoveConfirm}
        onClose={() => setRemoveId(null)}
      />

      {editItem && (
        <KoreanSchoolYearlyEditDialog
          item={editItem}
          open={!!editItem}
          onClose={() => setEditItem(null)}
        />
      )}

      <SectionLoader isLoading={isLoading} isFetching={isFetching}>
        <Grid container rowSpacing={2}>
          {sortedItems.map(item => (
            <Grid item xs={12} key={item.id}>
              <MainCard
                id={item.id}
                text={getCardText(item)}
                onEdit={() => setEditItem(item)}
                onRemove={setRemoveId}
                date={
                  item.lastModifiedDate || item.createdDate
                    ? moment(item.lastModifiedDate || item.createdDate).format('DD.MM.YYYY HH:mm')
                    : undefined
                }
              />
            </Grid>
          ))}
        </Grid>
      </SectionLoader>
    </>
  )
}
